import { createCalculators } from "@/components/calculator/calculator";
import { createTrustingInfo } from "../trusting-info/trusting-info";
import "./section-calculator.css";

export const createSectionCalculator = () => {
  createTrustingInfo();
  createCalculators();
};
